import {
    Component,
    inject,
    signal,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterModule,
} from '@angular/router'
import { NgIcon } from '@ng-icons/core'
import { filter } from 'rxjs'
import { HeaderProfileMenuComponent } from '../header-profile-menu/header-profile-menu.component'

@Component({
    selector: 'app-header-client-dashboard',
    imports: [RouterModule, NgIcon, HeaderProfileMenuComponent],
    templateUrl: './header-client-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-client-dashboard.component.css',
})
export class HeaderClientDashboardComponent {
    userName = input<string>('')
    userRole = input<string>('')
    userEmail = input<string>('')
    pageTitle = signal<string>('')
    showSearch = signal<boolean>(false)

    sidebarToggle = output<void>()

    private router = inject(Router)
    private activatedRoute = inject(ActivatedRoute)

    constructor() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntilDestroyed(),
            )
            .subscribe(() => this.updatePageTitle())
        this.updatePageTitle()
    }

    private updatePageTitle() {
        let route = this.activatedRoute.snapshot
        while (route.firstChild) {
            route = route.firstChild
        }
        this.pageTitle.set(route.data['pageTitle'] ?? '')
    }

    toggleSidebar() {
        this.sidebarToggle.emit()
    }

    toggleSearch() {
        this.showSearch.update((isVisible) => !isVisible)
    }
}
